/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_EmptyInputs */

const vi_notif_empty = /** @type {(inputs: Notif_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có thông báo`)
};

/**

* @param {Notif_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_empty = /** @type {((inputs?: Notif_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_empty(inputs)
});